<template>
  <div class="PaB-product__meta-wrapper" :class="{'PaB-product__meta-wrapper--compact': compact}">
    <dl class="PaB-product__meta">
      <div class="PaB-product__meta-item PaB-product__meta-vendor"
        :class="{'PaB-product__meta-vendor--images': images}">
        <dt></dt>
        <dd :class="{isBranded: product.brand === null}">by {{ product.brand }}</dd>
      </div>
      <div v-if="product.flower_type" class="PaB-product__meta-item PaB-product__meta-stat" :class=product.flower_type>
        <dt></dt>
        <dd>{{ product.flower_type.toUpperCase().replace(/_/g,' ') | '' }}</dd>
      </div>
      <div class="PaB-product__meta-item PaB-product__meta-stat">
        <dt>THC:</dt>
        <dd>{{ product.thc | cbd-thc-display }}</dd>
      </div>
      <div class="PaB-product__meta-item PaB-product__meta-stat">
        <dt>CBD:</dt>
        <dd>{{ product.cbd | cbd-thc-display }}</dd>
      </div>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
.PaB-product__meta {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin: 0 -4px;
  position: relative;

  &-item {
    align-items: center;
    display: flex;
    margin: 4px 4px;
  }

  dt,
  dd {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  dt {
    color: #555;
    font-weight: bold;
    padding-right: 0.25em;

    &:empty {
      display: none;
    }
  }

  dd {
    &.isBranded {
      visibility: hidden;
    }
  }

  &-stat {
    background: rgba(127, 127, 127, 0.2);
    border-radius: 3px;
    padding: 3px 6px;
  }

  &-vendor {
    width: 100%;
  }
  &-stat.sativa {
    background: #f74b3e;
    color: white;
  }
  &-stat.indica {
    background: #8d0fa3;
    color: white;
  }
  &-stat.sativa_hybrid {
    background: #ff850b;
    color: white;
  }
  &-stat.indica_hybrid {
    background: #4c35ef;
    color: white;
  }
  &-stat.hybrid {
    background: #07ad0f;
    color: white;
  }
}

// Hide vendor text on larger devices with images shown
// the vendor logo should be showing over the product image
// @media (min-width: 601px) {
//   .PaB-product__meta-vendor--images {
//     display: none;
//   }
// }

// Larger devices
// Compact view for non-images in list mode
@media (min-width: 768px) {
  .PaB-product__meta-wrapper--compact {
    & {
      display: flex;
      align-items: center;
    }
    .PaB-product__meta-vendor {
      order: 10;
      width: auto;
    }
    .PaB-product__meta {
      margin-top: 0;
    }
  }
}
</style>

<script>
export default {
  props: ['product', 'layout', 'useBrandText'],
  computed: {
    images () {
      return this.widgetOptions.style.product_images
    },
    compact () {
      return this.layout === 'list' && !this.images
    }
  }
}
</script>
